import type {
  EnvironmentId,
  ProjectId,
  ThreadId,
  GitPreparePullRequestThreadInput,
} from "@afar-research/contracts";
import { createStore } from "zustand/vanilla";
import type { DraftId } from "./composerDraftStore";

export interface PullRequestHandoffTarget {
  readonly environmentId: EnvironmentId;
  readonly projectId: ProjectId;
  readonly repository: string;
  readonly number: number;
  readonly url: string;
  readonly title: string;
  readonly headRefName: string;
  readonly baseRefName: string;
}
export interface PreparedPullRequestHandoff {
  readonly branch: string;
  readonly worktreePath: string | null;
  readonly threadId: ThreadId;
  readonly draftId: DraftId;
  readonly initialPrompt: string;
}
export const pullRequestHandoffIntents = {
  checkout: "Checkout only",
  explain: "Explain changes",
  fix: "Fix findings",
  conflicts: "Resolve conflicts",
} as const;
export type PullRequestHandoffIntent = keyof typeof pullRequestHandoffIntents;
interface HandoffState {
  intent: PullRequestHandoffIntent;
  mode: GitPreparePullRequestThreadInput["mode"];
  context: string;
  prepared: PreparedPullRequestHandoff | null;
  pending: boolean;
  error: string | null;
  uncertain: boolean;
  authorityToken: string | null;
}
export function createPullRequestHandoffSession() {
  return createStore<HandoffState>(() => ({
    intent: "checkout",
    mode: "new-worktree",
    context: "",
    prepared: null,
    pending: false,
    error: null,
    uncertain: false,
    authorityToken: null,
  }));
}
export type PullRequestHandoffSession = ReturnType<typeof createPullRequestHandoffSession>;
